//state
const state = () => ({
  loadingOb: {
    loadingResultado: false,
    loadingPerguntas: false,
    loadingDifal: false,
    loadingComplementoIcms: false,
    loadingStBeneficio: false,
    loadingStShow: false,
    loadingCenario: false,
    loadingAntecipacao: false,
    loadingCargaLiquida: false,
  }
})

//Getters
const getters = {
  getLoadingOb:(state) => {
   return state.loadingOb
  }
}

const mutations = {
  SET_LOADINGOB(state, {loading, index}) {
    state.loadingOb[index] = loading
  }
}

const actions = {
  setLoadingOb({commit}, {loading, index}) {
    commit('SET_LOADINGOB', {loading, index})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}